<template>
  <el-container class="add-dialog reduction-add-dialog">
    <header>
      <span>减购</span>
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h1">减购</div>
        <div class="h2">每一次增购都代表着客户的信任</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>客户名称</span>
            <div class="item-right">
              <el-select v-model="companyName" placeholder="请选择(必填)" filterable :filter-method="remoteMethod" @change="companyChange">
                <el-option v-for="item in userList" :key="item.id" :label="item.company_name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_cn"><i class="el-icon-warning"></i>{{err_cn}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>客户姓名</span>
            <div class="item-right">
              <el-input v-model="userName" placeholder="请输入内容" size="medium" readonly></el-input>
            </div>
            <div class="err" v-if="err_un"><i class="el-icon-warning"></i>{{err_un}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>联系电话</span>
            <div class="item-right">
              <el-input v-model="phone" placeholder="请输入(必填)" size="medium" readonly></el-input>
            </div>
            <div class="err" v-if="err_p"><i class="el-icon-warning"></i>{{err_p}}</div>
          </div>
          <div class="form-item">
            <span class="item-title"><span class="need">*</span>减购项目</span>
            <div class="item-right">
              <el-select v-model="project" placeholder="请选择(必填)" @change="peojectChange">
                <el-option v-for="item in projectData" :key="item.value" :label="item.label" :value="item.value" v-if="!(isLocal && (item.value == 2 || item.value == 3))"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_pro"><i class="el-icon-warning"></i>{{err_pro}}</div>
          </div>
          <div class="form-item" v-if="project == 1">
            <span class="item-title"><span class="need">*</span>减购坐席</span>
            <div class="item-right">
              <el-input v-model="peopleNumber" placeholder="请输入(必填)" size="medium"></el-input>
            </div>
            <div class="err" v-if="err_pn"><i class="el-icon-warning"></i>{{err_pn}}</div>
          </div>
          <div class="form-item" v-if="project == 2">
            <span class="item-title item-title2"><span><span class="need">*</span>减购</span><span>附件空间</span></span>
            <div class="item-right">
              <el-input v-model="attachment" placeholder="请输入(必填)" size="medium" class="gb" type="number">
              </el-input>
            </div>
            <div class="err" v-if="err_a"><i class="el-icon-warning"></i>{{err_a}}</div>
          </div>
          <div class="form-item" v-if="project == 3">
            <span class="item-title item-title2"><span><span class="need">*</span>减购</span><span>数据量</span></span>
            <div class="item-right">
              <el-input v-model="dataSize" placeholder="请输入(必填)" size="medium" class="tiao" type="number">
              </el-input>
            </div>
            <div class="err" v-if="err_ds"><i class="el-icon-warning"></i>{{err_ds}}</div>
          </div>
          <div class="form-item single">
            <span class="item-title">备注</span>
            <div class="item-right">
              <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSave">保 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import {reductionType} from '@/common/js/constant.js'
import tool from '@/common/js/tool.js'
export default {
  props: ['reduction'],
  data () {
    return {
      response: this.reduction,
      addType: '',
      companyName: '',
      userName: '',
      phone: '',
      attachment: '',
      dataSize: '',
      projectData: reductionType,
      project: 1,
      version: '1',
      peopleNumber: '',
      remark: '',
      err_cn: '',
      err_un: '',
      err_a: '',
      err_p: '',
      err_pn: '',
      err_pro: '',
      err_v: '',
      err_ds: '',
      userList: [],
      isLocal: true
    }
  },
  mounted () {
    this.userList = []
    // if (this.reduction.id) {
    HTTPServer.queryFormalUserList({'pageNum': 1, 'pageSize': 999, 'keyWord': this.reduction.company_name}, 'Loading').then((res) => {
      this.userList = res.dataList
      this.userList.map((item) => {
        if (item.id === this.reduction.id) {
          this.companyName = item.id
          this.userName = item.user_name
          this.phone = item.phone
          this.isLocal = item.deployment_type === '1'
        }
      })
    })
    // }
  },
  methods: {
    /** 保存 */
    dialogSave () {
      var b = this.dataTraversal()
      if (b) {
        var jsondata = {'account_id': this.companyName, 'user_name': this.userName, 'phone': this.phone, 'type': this.project, 'remark': this.remark}
        if (this.project === 1) {
          jsondata.allow_number = this.peopleNumber
          jsondata.operatorRecord = '减购席位' + this.peopleNumber + '个'
        } else if (this.project === 2) {
          jsondata.attachment_size = this.attachment
          jsondata.operatorRecord = '减购附件空间' + this.attachment + 'GB'
        } else if (this.project === 3) {
          jsondata.data_size = this.dataSize
          jsondata.operatorRecord = '减购数据上限' + this.dataSize + '条'
        }
        HTTPServer.saveReduction(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.$bus.emit('closeAddModal', true)
          this.$bus.emit('query-reduction-list', true)
        })
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_cn = ''
      this.err_un = ''
      this.err_a = ''
      this.err_p = ''
      this.err_pn = ''
      this.err_pro = ''
      this.err_v = ''
      this.err_ds = ''
      let reg = /^[1-9]\d*$/
      if (!this.companyName) {
        this.err_cn = '公司名称不能为空'
        return false
      }
      if (!this.userName) {
        this.err_un = '客户姓名不能为空'
        return false
      }
      if (!this.phone) {
        this.err_p = '联系电话不能为空'
        return false
      }
      if (!this.project) {
        this.err_pro = '减购项目不能为空'
        return false
      }
      if (this.project === 1 && !this.peopleNumber) {
        this.err_pn = '减购坐席不能为空'
        return false
      }
      if (this.project === 1 && !reg.test(this.peopleNumber)) {
        this.err_pn = '开通坐席只能为正整数'
        return false
      }
      if (this.project === 2 && !this.attachment) {
        this.err_a = '附件空间不能为空'
        return false
      }
      if (this.project === 2 && !reg.test(this.attachment)) {
        this.err_a = '附件空间只能为正整数'
        return false
      }
      if (this.project === 3 && !this.dataSize) {
        this.err_ds = '总数据量不能为空'
        return false
      }
      return true
    },
    /** 关闭弹窗 */
    dialogClose () {
      this.$bus.emit('closeAddModal', true)
    },
    /** 客户搜索   */
    remoteMethod (tag, tag1, tag2) {
      if (!tag) {
        this.companyName = undefined
        this.userList = []
      } else {
        HTTPServer.queryFormalUserList({'pageNum': 1, 'pageSize': 99, 'keyWord': tag}, 'Loading').then((res) => {
          this.userList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
      }
    },
    /** 客户选择 */
    companyChange () {
      let contains = tool.contains(this.userList, 'id', this.companyName)
      if (contains) {
        this.userName = contains.user_name
        this.phone = contains.phone
        this.isLocal = contains.deployment_type === '1'
        if (this.isLocal && (this.project === 2 || this.project === 3)) {
          this.project = 1
        }
      }
    },
    /** 项目切换 */
    peojectChange () {
      this.err_a = ''
      this.err_pn = ''
      this.err_pro = ''
      this.err_v = ''
      this.err_ds = ''
      this.peopleNumber = ''
      this.attachment = ''
      this.dataSize = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/reduction-add.vue